import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "@mui/material";
import request from "../../../api/request";
import { BackendAPI } from "../../../const/api";
import "./CreateMaterial.css";
import { useToast } from "../../../component/ToastBar";

const defaultForm = {
  code: "",
  name: "",
  model: "",
  unit: "",
  organization: "",
  source: "",
  category: "",
  warehouse: "",
  note: "",
  used: false,
  online_sales: false,
};
const CreateMaterial = () => {
  const toast = useToast();

  const [error, setError] = useState("");

  const [materialForm, setMaterialForm] = useState(defaultForm);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !materialForm.code ||
      !materialForm.name ||
      !materialForm.model ||
      !materialForm.unit ||
      !materialForm.source ||
      !materialForm.category ||
      !materialForm.warehouse
    ) {
      setError("必填字段都必须填写");
      return;
    }
    try {
      const res = await request.put(BackendAPI.createMaterial, materialForm);
      if (!res.success) {
        return;
      }
      // clear form
      toast("物料创建成功");
      setMaterialForm(defaultForm);
      setError("");
    } catch (error) {
      console.error("Error create material:", error);
      setError(`物料创建失败: ${error}`);
    }
  };

  return (
    <div className="create-material-form">
      <p>请输入物料信息</p>
      <Box component="form" noValidate onSubmit={handleSubmit}>
        <TextField
          required
          label="物料编码"
          name="code"
          value={materialForm.code}
          onChange={(e) =>
            setMaterialForm({ ...materialForm, code: e.target.value })
          }
        />
        <TextField
          required
          label="物料名称"
          name="material_name"
          value={materialForm.name}
          onChange={(e) =>
            setMaterialForm({ ...materialForm, name: e.target.value })
          }
        />
        <TextField
          required
          label="物料型号"
          name="model"
          value={materialForm.model}
          onChange={(e) =>
            setMaterialForm({ ...materialForm, model: e.target.value })
          }
        />
        <TextField
          required
          label="单位"
          name="unit"
          value={materialForm.unit}
          onChange={(e) =>
            setMaterialForm({ ...materialForm, unit: e.target.value })
          }
        />
        <FormControl sx={{ minWidth: 200 }} required>
          <InputLabel>来源</InputLabel>
          <Select
            required
            label="来源"
            name="source"
            value={materialForm.source}
            onChange={(e) =>
              setMaterialForm({ ...materialForm, source: e.target.value })
            }
            autoWidth
          >
            {["外购", "自制"].map((value) => {
              return (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 200 }} required>
          <InputLabel>存货类别</InputLabel>
          <Select
            required
            label="存货类别"
            name="category"
            value={materialForm.category}
            onChange={(e) =>
              setMaterialForm({ ...materialForm, category: e.target.value })
            }
            autoWidth
          >
            {["原材料", "自制半成品", "产成品"].map((value) => {
              return (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <TextField
          required
          label="仓库"
          name="warehouse"
          value={materialForm.warehouse}
          onChange={(e) =>
            setMaterialForm({ ...materialForm, warehouse: e.target.value })
          }
        />
        <TextField
          label="备注"
          name="note"
          value={materialForm.note}
          onChange={(e) =>
            setMaterialForm({ ...materialForm, note: e.target.value })
          }
        />
        <FormControl>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  defaultChecked
                  onChange={(e) =>
                    setMaterialForm({
                      ...materialForm,
                      used: e.target.checked,
                    })
                  }
                />
              }
              label="是否已使用"
            />
            <FormControlLabel
              control={
                <Switch
                  onChange={(e) =>
                    setMaterialForm({
                      ...materialForm,
                      online_sales: e.target.checked,
                    })
                  }
                />
              }
              label="是否网销"
            />
          </FormGroup>
        </FormControl>
        {error && (
          <div className="create-material-form error-message">{error}</div>
        )}
        <Button className="submit-button" type="submit" variant="contained">
          保存更改
        </Button>
      </Box>
    </div>
  );
};

export default CreateMaterial;
